import React, { useState } from 'react';
import { Icon } from 'antd';
import MyInput from 'components/controls/MyInput';

// Sprint 2.7.2A (Enterprise Communication Experience Modernization): a reusable, full-width input for
// sensitive/secret-adjacent configuration values (SMTP password reference, MSG91 authentication key
// reference, API keys, connection strings) — hidden by default with a Show/Hide toggle, per the sprint's
// "sensitive values must be hidden by default" requirement. Presentation only — does not change what is
// stored or how (still just a plain ConfigValue string via the existing update flow).
const SecretRefField = ({ name, value, onChange, heading, helpText, className, wrapClass, isRequired, errorState, errorMessage, disabled }) => {
  const [revealed, setRevealed] = useState(false);

  return (
    <div className={wrapClass}>
      <MyInput
        name={name}
        type={revealed ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        heading={heading}
        isRequired={isRequired}
        errorState={errorState}
        errorMessage={errorMessage}
        disabled={disabled}
        className={className}
      />
      <button
        type="button"
        className="ent-secret-toggle"
        onClick={() => setRevealed(!revealed)}
        aria-label={revealed ? 'Hide value' : 'Show value'}
      >
        <Icon type={revealed ? 'eye-invisible' : 'eye'} /> {revealed ? 'Hide' : 'Show'}
      </button>
      {helpText && <div className="ent-field-help">{helpText}</div>}
    </div>
  );
};

export default SecretRefField;
